export const weekDays = [
	{
		short: 'Sun',
		full: 'Sunday',
	},
	{
		short: 'Mon',
		full: 'Monday',
	},
	{
		short: 'Tue',
		full: 'Tuesday',
	},
	{
		short: 'Wed',
		full: 'Wednesday',
	},
	{
		short: 'Thu',
		full: 'Thursday',
	},
	{
		short: 'Fri',
		full: 'Friday',
	},
	{
		short: 'Sat',
		full: 'Saturday',
	},
]

export const monthList = [
	{ full: 'January', short: 'Jan', monthIndex: 1 },
	{ full: 'February', short: 'Feb', monthIndex: 2 },
	{ full: 'March', short: 'Mar', monthIndex: 3 },
	{ full: 'April', short: 'Apr', monthIndex: 4 },
	{ full: 'May', short: 'May', monthIndex: 5 },
	{ full: 'June', short: 'Jun', monthIndex: 6 },
	{ full: 'July', short: 'Jul', monthIndex: 7 },
	{ full: 'August', short: 'Aug', monthIndex: 8 },
	{ full: 'September', short: 'Sep', monthIndex: 9 },
	{ full: 'October', short: 'Oct', monthIndex: 10 },
	{ full: 'November', short: 'Nov', monthIndex: 11 },
	{ full: 'December', short: 'Dec', monthIndex: 12 },
]

export const viewList = [
	{ label: 'Day', value: 'day' },
	{ label: 'Month', value: 'month' },
	{ label: 'Year', value: 'year' },
]
